import type { CallEntityType } from '@/types/twilio';

export function incomingContactPath(
  entityType?: CallEntityType | null,
  entityId?: string | null
): string | null {
  if (!entityId) return null;
  if (entityType === 'individuals') return `/individual/${entityId}`;
  if (entityType === 'companies') return `/company/${entityId}`;
  return null;
}

export function incomingGroupLabel(callGroupName?: string | null): string {
  const group = callGroupName?.trim();
  return group ? `Inbound · ${group}` : 'Inbound';
}
